import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

/**
 * Voice Textarea Input Component for dynamic forms
 * Wraps the voice-ion-textarea component to provide voice input capabilities
 */

@Component({
  selector: "voice-textarea-input",
  templateUrl: "voice-textarea-input.html",
})
export class VoiceTextareaInputComponent implements OnInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  placeholder: string = "placeholder";
  rows: number = 5;
  maxLength: number = 1000; // default
  minLength: number;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;
  showCharCounter: boolean = false;
  spaceBetween: boolean = true;
  display: string = "contents";

  constructor(public formBuilder: FormBuilder) {}

  ngOnInit(): void {
    let config = this.config;
    this.id = config.id;
    this.componentId = this.config.componentId;
    this.label = config.label !== undefined ? config.label : config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = config.readonly;
    if (config.placeholder) {
      this.placeholder = config.placeholder;
    }
    if (config.rules && config.rules.spaceBetween == false) {
      this.spaceBetween = false;
    }
    if (config.rules && config.rules.display) {
      this.display = config.rules.display;
    }

    this.group.addControl(this.id, this.formBuilder.control(undefined));
    this.disabled = this.group.controls[this.id].disabled;
    let selfControl = this.group.controls[this.id];

    this.setRules(config, selfControl);

    selfControl.valueChanges.subscribe((data) => {
      if (this.disabled !== selfControl.disabled) {
        this.disabled = selfControl.disabled;
      }
    });
  }

  setRules(config, selfControl) {
    var validators = [];
    if (config.rules) {
      if (config.rules.rows) {
        this.rows = config.rules.rows;
      }
      if (config.rules.required) {
        this.required = config.rules.required;
        validators.push(Validators.required);
      }
      if (config.rules.minLength) {
        this.minLength = config.rules.minLength;
        validators.push(Validators.minLength(this.minLength));
      }
      if (config.rules.maxLength) {
        this.maxLength = config.rules.maxLength;
        validators.push(Validators.maxLength(this.maxLength));
      }
      if (config.rules.showCharCounter) {
        this.showCharCounter = config.rules.showCharCounter;
      }
    } else {
      this.required = false;
      this.minLength = 0;
      this.maxLength = 1000;
      selfControl.clearValidators();
    }
    var composedValidators = Validators.compose(validators);
    selfControl.setValidators(composedValidators);
    selfControl.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/voice-textarea-input/voice-textarea-input.ts